<mat-table mat-table [dataSource]="dataSource">
  <ng-container matColumnDef="query">
    <mat-header-cell *matHeaderCellDef>{{ 'searches.query' | translate }}</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <mat-chip-list
        *ngIf="element?.query"
        class="query-list"
        [attr.aria-label]="
          ('searches.query' | translate) + ' ' + getSearchTerms(element?.searchTerms)
        ">
        <mat-chip
          *ngFor="let term of element.searchTerms"
          [selectable]="false"
          (keydown.enter)="repeatSearch(element)"
          (keydown.space)="repeatSearch(element)"
          (click)="repeatSearch(element)"
          [tabIndex]="0">
          <span *ngIf="term.icon" class="odilo-icon">{{ term.icon }}</span>
          <span>{{ term.term }}</span>
        </mat-chip>
      </mat-chip-list>

      <span class="empty" *ngIf="!element.query" [tabIndex]="0">{{ 'searches.noQuery' | translate }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="facets">
    <mat-header-cell *matHeaderCellDef>{{ 'user.searches.filters' | translate }}</mat-header-cell>
    <mat-cell *matCellDef="let element">
      <mat-chip-list
        *ngIf="element?.facets"
        class="facets-list"
        [attr.aria-label]="
          ('user.searches.filters' | translate) + ' ' + getFiltersLabels(element?.filters)
        ">
        <mat-chip
          *ngFor="let filter of element.filters"
          [selectable]="false"
          (keydown.enter)="repeatSearch(element)"
          (keydown.space)="repeatSearch(element)"
          (click)="repeatSearch(element)"
          [tabIndex]="0">
          <span>{{ filter.label }}</span>
        </mat-chip>
      </mat-chip-list>

      <span class="empty" *ngIf="!element.facets" [tabIndex]="0">{{ 'searches.noFilter' | translate }}</span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="total">
    <mat-header-cell *matHeaderCellDef>{{ 'searches.results' | translate }}</mat-header-cell>
    <mat-cell
      *matCellDef="let element"
      [tabIndex]="0"
      [attr.aria-label]="('searches.results' | translate) + ' ' + element.total"
      >{{ element.total }}</mat-cell
    >
  </ng-container>

  <ng-container matColumnDef="date">
    <mat-header-cell *matHeaderCellDef>{{ 'searches.date' | translate }}</mat-header-cell>
    <mat-cell
      *matCellDef="let element"
      [tabIndex]="0"
      [attr.aria-label]="('searches.date' | translate) + ' ' + (element.searchDate | date)"
      >{{ element.searchDate | date }}</mat-cell
    >
  </ng-container>

  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef class="sticky">{{ 'common.actions' | translate }}</mat-header-cell>
    <mat-cell *matCellDef="let element" class="mat-table-actions-cell sticky">
      <button
        mat-flat-button
        class="only-icon"
        (click)="copyToClipboard(element, $event)"
        [opacTooltip]="'tooltip.copyLink' | translate"
        [attr.aria-label]="'tooltip.copyLink' | translate">
        <span class="odilo-icon" aria-hidden="true">link</span>
      </button>

      <ng-container *ngIf="history">
        <button
          mat-flat-button
          class="only-icon"
          (click)="saveSearch(element, $event)"
          [opacTooltip]="'tooltip.saveSearch' | translate"
          [attr.aria-label]="'tooltip.saveSearch' | translate">
          <span class="odilo-icon" aria-hidden="true">save</span>
        </button>
      </ng-container>

      <ng-container *ngIf="!history">
        <button
          mat-flat-button
          class="only-icon"
          (click)="deleteSearch(element, $event)"
          [opacTooltip]="'common.delete' | translate"
          [attr.aria-label]="'common.delete' | translate">
          <span class="odilo-icon" aria-hidden="true">delete</span>
        </button>
      </ng-container>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row
    *matRowDef="let row; columns: displayedColumns"
    (keydown.enter)="repeatSearch(row)"
    (keydown.space)="repeatSearch(row)"
    (click)="repeatSearch(row)"
    [tabIndex]="0"></mat-row>
</mat-table>
